import { render, staticRenderFns } from "./HeroProducts.vue?vue&type=template&id=f5f20868&scoped=true&"
import script from "./HeroProducts.vue?vue&type=script&lang=js&"
export * from "./HeroProducts.vue?vue&type=script&lang=js&"
import style0 from "./HeroProducts.vue?vue&type=style&index=0&id=f5f20868&prod&lang=scss&"
import style1 from "./HeroProducts.vue?vue&type=style&index=1&id=f5f20868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f20868",
  null
  
)

export default component.exports